import Base from './base'
import urls from 'config/urls'

class Marketing extends Base {
  findClientHomeFeatured (opts) {
    return this.httpGet({
      url: urls.marketing.findClientHomeFeatured,
      data: opts
    })
  }

  createClientHomeFeatured (opts) {
    return this.httpPost({
      url: urls.marketing.createClientHomeFeatured,
      data: opts
    })
  }

  updateClientHomeFeatured (opts) {
    return this.httpPost({
      url: urls.marketing.updateClientHomeFeatured,
      data: opts
    })
  }

  deleteClientHomeFeatured (opts) {
    return this.httpPost({
      url: urls.marketing.deleteClientHomeFeatured,
      data: opts
    })
  }
}

export default new Marketing



// WEBPACK FOOTER //
// ./src/models/marketing.js